import { Auth } from 'aws-amplify';
import moment from 'moment';
const BASE_INSTORE_API = process.env.REACT_APP_BASE_INSTORE_API_URI;

export const getStoreAuth = () => 
  new Promise( async (resolve, reject) => {
    let didTimeOut = false;
    try{
      const headers = {
          'Content-Type': 'application/json',
      }
  
      const timeout = setTimeout(() => {
        didTimeOut = true;
        resolve('not in store')
      }, 5000);
  
      const response = await fetch( `${BASE_INSTORE_API}/storeAuth`, {
        headers,
        method: 'GET',
      });
      
      if (!didTimeOut) {
        const {token} = await response.json()
        clearTimeout(timeout);
        resolve(token);
      }
    } catch(error){
      resolve('not in store');
    }
  })



export const validateSession = async () => {
  const isInStore = await localStorage.getItem('isInStore');
  if (isInStore) {
    const tokenAuthTime = await localStorage.getItem('authTime')
    const authTime = moment(tokenAuthTime).toISOString();
    const currTime = moment();
    const diffTime = currTime.diff(authTime, 'hours')
    if (diffTime >= 12){
      localStorage.clear();
      return false;
    }
    return true
  } else {
    try {
      await Auth.currentAuthenticatedUser();
      return true;
    } catch (error){
      localStorage.clear();
      return false
    }
  }
}